import { TableCell, TableRow } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/icons/deleteIcon.svg";
import HtmlTooltip from "components/Elements/HtmlTooltip";
import { isoDateWithoutTimeZone } from "helpers/utils";
import React from "react";

const NoteRow = ({ row, classes, onDeleteNote, disabled, onViewNote }) => {
	return (
		<TableRow>
			<TableCell>{row?.name}</TableCell>
			<TableCell>{isoDateWithoutTimeZone(row.date + "Z")}</TableCell>
			<TableCell className="note-field" style={{ whiteSpace: "unset", maxWidth: "400px" }}>
				<HtmlTooltip
					title={<div dangerouslySetInnerHTML={{ __html: row.note || "" }} />}
				>
					<div
						className="max-two-line"
						style={{ width: "100%" }}
						dangerouslySetInnerHTML={{ __html: row.note || "" }}
					/>
				</HtmlTooltip>
			</TableCell>
			<TableCell>
				<p className="new-link" onClick={() => onViewNote(row?.note)}>
					View
				</p>
			</TableCell>
			<TableCell style={{ width: "50px" }}>
				{disabled ? null : (
					<DeleteIcon className={classes.deleteIcon} onClick={onDeleteNote} />
				)}
			</TableCell>
		</TableRow>
	);
};

export default NoteRow;
